import { render, staticRenderFns } from "./ACategoriaMoodleInscribir.vue?vue&type=template&id=33f19293&scoped=true"
import script from "./ACategoriaMoodleInscribir.vue?vue&type=script&lang=js"
export * from "./ACategoriaMoodleInscribir.vue?vue&type=script&lang=js"
import style0 from "./ACategoriaMoodleInscribir.vue?vue&type=style&index=0&id=33f19293&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f19293",
  null
  
)

export default component.exports